<mat-form-field>
  <mat-label>{{ 'core.customer' | translate }}</mat-label>
  <input
    type="text"
    placeholder="{{ 'customer.search.placeholder' | translate }}"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    >
  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    [displayWith]="displayCustomer"
    >
    @if ((actionPending$ | async)) {
      <mat-option class="is-loading">
        <mat-spinner diameter="30"></mat-spinner>
      </mat-option>
    }
    @if (false === (actionPending$ | async)) {
      @for (customer of filteredCustomers$ | async; track customer) {
        <mat-option [value]="customer">
          {{ customer.code }}
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
